import { PLAN_KEY } from '../../constants'
import { getValueReduxUtil } from '../../../../redux'

function isRecommendedPlanUtil (plan) {
  return !!getValueReduxUtil(
    plan, PLAN_KEY.RECOMMENDED_AT
  )
}

export default isRecommendedPlanUtil
